module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://astron.ems2shop.dev.lz.aws.singtel.com"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Singtel.com","short_name":"Singtel.com","start_url":"/","background_color":"#FFFFFF","theme_color":"#ED1A3D","display":"standalone","icon":"src/assets/images/singtel-logo-white.png","icon_options":{"purpose":"maskable"},"crossOrigin":"use-credentials","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","cacheDigest":"4c4223883db8a93ca33d743c045b20cc"},
    },{
      plugin: require('../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"showSpinner":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-DERMK2N1S8"],"pluginConfig":{"head":true}},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
